export interface RDFImportData {
  databaseId: string;
  options: object;
  filePath?: string;
  document?: string | ArrayBuffer;
  namedGraphs?: string[];
}
export interface RDFImportFile extends Omit<RDFImportData, 'document'> {
  filePath: string;
}
export interface RDFImportDocument extends Omit<RDFImportData, 'filePath'> {
  document: string;
}

export const ALLOWABLE_FILE_SIZE_IN_MB = 500;
